module.exports = "https://web-assets.ifttt.com/packs/media/icons/icon-plug-c8f70cd2.svg";